import { blend, clamp } from './interpolate';

const scoreAed = (share) => clamp(20 + share * 55, 0, 90);
const scoreCurrencySpread = (count) => {
  if (count <= 1) return 90;
  if (count <= 3) return 90 - ((count - 1) / 2) * (90 - 55);
  if (count <= 5) return 55 - ((count - 3) / 2) * (55 - 30);
  return clamp(30 - (count - 5) * 5, 20, 30);
};
const scoreMainland = (share) => {
  if (share <= 0.5) return 30 + share * 50;
  return 55 + ((share - 0.5) / 0.5) * (85 - 55);
};
const scoreExportMod = (share) => {
  if (share <= 0.1) return 90;
  if (share <= 0.25) return 90 - ((share - 0.1) / 0.15) * (90 - 65);
  return clamp(65 - (share - 0.25) * 120, 30, 65);
};

export const scoreD6 = (inputs) => {
  const aed = scoreAed(inputs.aedShare);
  const currency = scoreCurrencySpread(inputs.distinctCurrencies);
  const mainland = scoreMainland(inputs.mainlandConcentration);
  const exp = scoreExportMod(inputs.exportRevenueShare);

  const score = blend([
    { score: aed, weight: 0.35 },
    { score: currency, weight: 0.2 },
    { score: mainland, weight: 0.25 },
    { score: exp, weight: 0.2 },
  ]);

  return { score, subScores: { aed, currency, mainland, exp } };
};
